import { useCallback, useEffect } from "react";
import './trade-in-result.scss';
import langs from "../../../../common/services/languageService.js";
const { labels } = langs;

function TradeInResult({ message, formSubmitProps }) {
  const { setSubmitFn, setButtonLabel } = formSubmitProps;

  const onSubmit = useCallback(() => {}, []);

  useEffect(() => {
    setButtonLabel(labels.Close());
  }, [setButtonLabel]);

  useEffect(() => {
    setSubmitFn(() => onSubmit);
    return () => {
      setSubmitFn(null);
    };
  }, [setSubmitFn, onSubmit]);

  return (
    <div className="trade-in-result">
      <span className="trade-in-result--info bold">{message}</span>
    </div>
  );
}

export default TradeInResult;
